import { httpV1 as http } from '../api';

const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiT2N0YSJ9.8EJy7xvSqyeHhpSiR1Zh_SRnOxvUUdqEcgj-SH4pTGE';
const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function getProposals(params) {
  const { data } = await http.get(`${ALT_API_URL}/proposals`, params ? { params } : '');
  return data;
}

export async function getProposalsByURL(url) {
  const { data } = await http.get(url);
  return data;
}

export async function getDetailsProposals(proposalId, bank) {
  const params = { bank };
  return http.get(`/proposals/${proposalId}/details`, { params });
}

export async function updateProposals(proposalId, data) {
  return http.put(`/proposals/${proposalId}`, data);
}

export async function getProposalsStatus(idProposal) {
  const params = { proposal: idProposal };
  return http.get('/antecipate-fgts/proposal', { params });
}

export async function createProposal(data) {
  const { data: _data } = await http.post('/proposals/admin', data);

  return _data;
}

export async function downloadCSV(params) {
  return http
    .get(`${ALT_API_URL}/proposals`, { params })
    .then(({ data }) => data);
}

export async function history(id) {
  return http
    .get(`/proposals/${id}/history`)
    .then(({ data }) => data);
}

export async function getStatusList() {
  return http
    .get('/proposals/status')
    .then(({ data }) => data);
}

export async function confirm(params) {
  delete http.defaults.headers.common.Authorization; // prevent CORS errors
  delete http.defaults.headers.common['X-Authorization']; // prevent CORS errors

  http.defaults.headers.common = { Authorization: `Bearer ${token}` };

  return http.get('/fgts/simulation', { params });
}

export async function massStatusUpdate(proposalsToChange, statusToSet) {
  const formattedArray = proposalsToChange.map((proposal) => ({
    id: proposal,
    status: statusToSet,
  }));

  return http.patch('/proposals', ...[formattedArray]);
}

export async function getStatusResume(params) {
  return http
    .get(`${ALT_API_URL}/proposals/status-resume`, { params })
    .then(({ data }) => data);
}
